// extracted by mini-css-extract-plugin
export default {"top":"home_top__+41EY","artList":"home_artList__yxyIQ"};